/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_Document_ServiceInputs */

const en_mapping_system_document_service = /** @type {(inputs: Mapping_System_Document_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document service`)
};

/**
* | output |
* | --- |
* | "Document service" |
*
* @param {Mapping_System_Document_ServiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_document_service = /** @type {((inputs?: Mapping_System_Document_ServiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_Document_ServiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_document_service(inputs)
});